module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.addMaliciousEntry(false)
      }
    }
  }, [_vm._v("Add Entry")]), _vm._v(" "), _c('button', {
    staticClass: "button is-dark",
    on: {
      "click": function($event) {
        _vm.addMaliciousEntry(true)
      }
    }
  }, [_vm._v("Add Malicious Entry")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-4 sq-vux-bg"
  }, _vm._l((_vm.vuxMessages), function(message, index) {
    return _c('Card', {
      key: index,
      attrs: {
        "header": message
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_vm._m(0), _vm._v(" "), _c('h1', [_vm._v("What was sent :")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentMessage))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("Vux UI Framework")]), _vm._v(" "), _c('p', [_vm._v("Vux is UI a Framework based on vue with "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux"
    }
  }, [_vm._v(" 7.5k stars")]), _vm._v(" on Github")]), _vm._v(" "), _c('p', [_vm._v("It "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/search?utf8=%E2%9C%93&q=v-html&type="
    }
  }, [_vm._v("currently")]), _vm._v(" implements multiple time the v-html tag where it can possibly be user filled fields")]), _vm._v(" "), _c('p', [_vm._v("The component on the left is vux's "), _c('strong', [_vm._v("Card")]), _vm._v(" component. Here we hijack the "), _c('strong', [_vm._v("header")]), _vm._v(" field.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bb97bde"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vux.vue
// module id = 133
// module chunks = 1